import { Component } from '@angular/core';

interface ProofMetric {
  value: string;
  label: string;
}

@Component({
  selector: 'app-home-proof-strip',
  standalone: true,
  templateUrl: './home-proof-strip.component.html'
})
export class HomeProofStripComponent {
  readonly metrics: ProofMetric[] = [
    { value: '+30', label: 'leiloeiros monitorados' },
    { value: '+10 mil', label: 'imóveis disponíveis' },
    { value: '27', label: 'estados cobertos' },
    { value: '24h', label: 'atualização diária' }
  ];
}
